// extracted by mini-css-extract-plugin
export default {"container":"FinalCalculations_container__QpoXm","buttonGroup":"FinalCalculations_buttonGroup__fDKZF","calcButton":"FinalCalculations_calcButton__a8nJD"};